import {DetailsWidget} from "../../challenge/widget/details";
import React, {useCallback, useContext, useEffect, useMemo} from "react";
import styled from "styled-components";
import {ButtonWidget} from "../../../widget/pub/button_widget";
import {ModalContext} from "../../../provider/model_provider";
import {TisArbitrationModel} from "../widget/tis_arbitration_model";
import {useWait} from "../../../utils/wait_fn";
import {HttpServer} from "../../../net/http_server";
import {useLocation, useParams} from "react-router-dom";
import {DetailsInterface} from "../../../interface/challenge/details";
import {ADMIN_TYPE} from "../../admin/bottom_list";
import {ChallengeResultWidget} from "../../admin/widget/challenge_result";
import {checkFn, StatusEnum} from "../../../utils/status_check";

export const ArbitrationPage: React.FC = () => {
    const {onPresent} = useContext(ModalContext);
    const {data, request, setData} = useWait<DetailsInterface>(HttpServer.assessment)
    const params = useParams<{ id: string, type: string }>();

    const location = useLocation();
    const type:any = useMemo(()=>{
        return new URLSearchParams(location.search).get('type');
    },[location]);

    const handleArbitration = useCallback((type: string) => {

        onPresent(<TisArbitrationModel updateFn={() => setData({...data, status: "disable"})}
                                       claim_hash={data.cover_hash}
                                       claim_id={data.claim_id}
                                       type={type}
                                       isAdmin={params.type === ADMIN_TYPE}
        />)
    }, [data, request, params])


    useEffect(() => {
        request(params.id);
    }, [])

    return (
        <>
            <WapStyle>
                <div className="title">
                    ASESSMENT
                </div>
                <DetailsWidget model={data}/>
                <div className="buttons">
                    <ButtonWidget
                        onClick={() => handleArbitration('Pass')}
                        bgColor={'#0064FD'}
                        disable={!checkFn(StatusEnum.arbiter, data?.status)}
                        text={'Accept Claim'}
                        size={{x: 10, y: 40}}
                    />
                    <ButtonWidget
                        onClick={() => handleArbitration('Deny')}
                        bgColor={'#0064FD'}
                        text={'Deny Claim'}
                        disable={!checkFn(StatusEnum.arbiter, data?.status)}
                        size={{x: 10, y: 40}}
                    />
                </div>
            </WapStyle>
            {params.type === ADMIN_TYPE && type && <ChallengeResultWidget type={type}/>}
        </>
    );
}

const WapStyle = styled.div`
  background-color: white;
  margin-top: 20px;

  .buttons {
    display: flex;
    justify-content: space-around;
    padding: 50px 0;
    width: 60%;
    margin: 0 auto;
  }

  .title {
    height: 55px;
    background-color: #EAF2FF;
    line-height: 55px;
    padding-left: 20px;
  }
`
